import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Push-pin — round head, flared collar, slim shaft to a sharp tip.
 *  Drawn at a slight tilt so it reads as a pin, not a balloon. Means
 *  "pinned / sticky" in the taxonomy picker. */
export function IcnPin(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="pin">
      {/* Head */}
      <circle cx="9" cy="5" r="3" />
      {/* Collar — small ribbon below the head */}
      <path d="M6.7 7.4 L9.6 9.5" />
      {/* Shaft to tip */}
      <path d="M8.2 8.2 L3 14" />
    </Svg>
  );
}
